<template>
  <div class="buy-wrapper container">
    <div class="loading-wrapper" v-if="loading">
      <div class="loading"></div>
    </div>
    <img class="wave-top" src="@/assets/img/wave_top_page.png" />
    <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />

    <div class="all-wrapper">
      <div class="watch-wrapper" v-if="$route.query.item === 'watch'">
        <div class="image-wrapper">
          <img
            class="watch-1"
            :src="require('@/assets/img/upmood_watch_1.png')"
            alt=""
          />
          <img
            class="watch-2"
            :src="require('@/assets/img/upmood_watch_2.png')"
            alt=""
          />
        </div>

        <div class="title-container">
          <img
            class="watch-logo"
            :src="require('@/assets/img/upmood_watch_logo-1.png')"
            alt=""
          />

          <h2>Watch how you’re feeling.</h2>
          <p class="desc">
            To the better and deeper emotional awareness journey.
          </p>

          <img
            class="features"
            :src="require(`@/assets/img/watch_featuress.png`)"
            alt=""
          />
          <!-- <p class="note">All items will be processed on December 9, 2020.</p> -->
        </div>
      </div>

      <div class="buy-wrapper container">
        <div class="wrapper customer">
          <div class="content">
            <div class="band">
              <h1><span class="step">1</span> Cart</h1>

              <!-- <div class="details">
                        <div class="colors">
                        <h2>Upmood {{ item }}</h2>
                        <span
                            class="black"
                            @click="setBandColor(1)"
                            :class="{ active: this.band.color === 1 }"
                        ></span> -->
              <!-- <span class="sea-green" @click="setBandColor(2)" :class="{'active' : this.band.color===2}"></span>
                                    <span class="yellow" @click="setBandColor(3)" :class="{'active' : this.band.color===3}"></span> -->
              <!-- </div>

                        <div class="qty">
                        <h2>Qty:</h2>
                        <button
                            class="button-white"
                            @click="setQty(-1)"
                            :disabled="this.band.qty === 1"
                        >
                            -
                        </button>
                        <h2>{{ band.qty }}</h2>
                        <button
                            class="button-white"
                            @click="setQty(1)"
                        >
                            +
                        </button>
                        </div>
                    </div> -->
              <div class="strap-wrapper">
                <div class="item-wrapper">
                  <div class="item-container band">
                    <!-- <span class="item"></span> -->
                    <h2>Upmood {{ item }}</h2>
                  </div>

                  <div class="item-details">
                    <span
                      class="black"
                      @click="setBandColor(1)"
                      :class="{ active: band.color === 1 }"
                    ></span>

                    <div class="qty">
                      <h2>Qty:</h2>
                      <button
                        class="button-white"
                        @click="setQty(-1)"
                        :disabled="band.qty === 0 || !editInfo"
                      >
                        -
                      </button>
                      <h2>{{ band.qty }}</h2>
                      <button
                        class="button-white"
                        @click="setQty(1)"
                        :disabled="!editInfo"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="strap-wrapper" v-if="item === 'Watch'">
                <h2 class="strap">Strap</h2>

                <div
                  class="item-wrapper"
                  v-for="(strap, index) in straps"
                  :key="index"
                >
                  <div class="item-container">
                    <span class="item">{{ strap.name }}</span>
                    <span class="price">{{ strap.price }} USD</span>
                  </div>

                  <div class="item-details">
                    <img
                      :src="require(`@/assets/img/${strap.img}.png`)"
                      alt=""
                    />
                    <div class="qty">
                      <h2>Qty:</h2>
                      <button
                        class="button-white"
                        @click="setStrapQty(strap.code, -1)"
                        :disabled="
                          addons.filter(i => i.code === strap.code)[0].qty ===
                            0 || !editInfo
                        "
                      >
                        -
                      </button>
                      <h2>
                        {{ addons.filter(i => i.code === strap.code)[0].qty }}
                      </h2>
                      <button
                        class="button-white"
                        @click="setStrapQty(strap.code, 1)"
                        :disabled="
                          addons.filter(i => i.code === strap.code)[0].qty ===
                            10 || !editInfo
                        "
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="content">
            <h1>
              <span class="step">2</span> Customer Information
              <img
                src="@/assets/img/edit.png"
                class="icon-edit"
                @click="edit()"
                v-show="!editInfo"
              />
            </h1>

            <div class="customer-info" v-show="editInfo">
              <div class="info">
                <InputField
                  type="text"
                  placeholder="Firstname"
                  label="Firstname"
                  v-model="firstname"
                  :error="
                    error && error.first_name ? error.first_name[0] : null
                  "
                />
                <InputField
                  type="text"
                  placeholder="Lastname"
                  label="Lastname"
                  v-model="lastname"
                  :error="error && error.last_name ? error.last_name[0] : null"
                />
                <InputField
                  type="text"
                  placeholder="Email"
                  label="Email"
                  v-model="email"
                  :error="error && error.email ? error.email[0] : null"
                />
              </div>

              <h2>Delivery Address</h2>
              <div class="delivery">
                <InputField
                  type="text"
                  placeholder="Company"
                  label="Company"
                  v-model="company"
                  :error="error && error.company ? error.company[0] : null"
                />

                <InputField
                  type="text"
                  placeholder="Bldg/Apt. Name"
                  label="Bldg/Apt. Name"
                  v-model="bldg"
                  :error="error && error.bldg ? error.bldg[0] : null"
                />
                <InputField
                  type="text"
                  placeholder="Street"
                  label="Street"
                  v-model="street"
                  :error="error && error.street ? error.street[0] : null"
                />
                <InputField
                  type="text"
                  placeholder="City"
                  label="City"
                  v-model="city"
                  :error="error && error.city ? error.city[0] : null"
                />
                <InputField
                  type="text"
                  placeholder="Zip Code"
                  label="Zip Code"
                  v-model="zipCode"
                  :error="error && error.zipCode ? error.zipCode[0] : null"
                />
                <CustomSelect
                  placeholder="Country"
                  label="Country"
                  itemText="name"
                  itemKey="id"
                  :items="countries"
                  :loading="countryListLoading"
                  v-model="country"
                  :error="error && error.country ? error.country[0] : null"
                />

                <div class="group">
                  <label :class="{ disabled: !this.country }">
                    {{ this.country ? this.country.int_dialing : "--" }}
                  </label>

                  <InputField
                    type="tel"
                    placeholder="Mobile"
                    label="Mobile"
                    v-model="mobile"
                    :error="error && error.mobile ? error.mobile[0] : null"
                    :disabled="!this.country"
                  />
                </div>

                <!-- <div class="kickstarter-wrapper" v-if="item === 'Watch'">
                  <input
                    type="checkbox"
                    name="kickstarter"
                    v-model="isKickstarter"
                    class="checkbox"
                  />
                  <label class="label" for="kickstarter"
                    >Kickstarter Backer</label
                  >
                </div>

                <div class="kickstarter-number" v-if="isKickstarter">
                  <h3>Kickstarter Backer no.</h3>
                  <InputField
                    type="text"
                    v-model="kickstarterNumber"
                    :error="
                      error && error.kickstarter_number
                        ? error.kickstarter_number[0]
                        : null
                    "
                  />
                  <h5>
                    If you are not sure about your backer number, please contact
                    us at our support@upmood.com
                  </h5>
                </div> -->
              </div>

              <div class="next">
                <button
                  class="button-cyan "
                  @click="next()"
                  :disabled="
                    !validateCustomerInfo ||
                      buttonLoading ||
                      (strapQty < 1 && band.qty < 1)
                  "
                >
                  {{ !buttonLoading ? "Next" : "Loading" }}
                </button>
              </div>
            </div>

            <div class="customer-info-summary" v-show="!editInfo">
              <div>
                <p>Firstname: {{ firstname }}</p>
                <p>Lastname: {{ lastname }}</p>
                <p>Email: {{ email }}</p>
              </div>

              <h2>Delivery Address</h2>
              <div>
                <p>Company: {{ company }}</p>
                <p>Bldg/Apt. name: {{ bldg }}</p>
                <p>Street: {{ street }}</p>
                <p>City: {{ city }}</p>
                <p>Zip Code: {{ zipCode }}</p>
                <p>Country: {{ country ? country.name : "" }}</p>
                <p>Mobile: {{ mobile }}</p>
              </div>
            </div>
          </div>

          <div class="content">
            <h1 :class="{ inactive: step <= 2 }">
              <span class="step">3</span> Delivery
            </h1>

            <div class="delivery" v-if="step > 2">
              <div v-show="delivery === 1">
                <div
                  class="details"
                  @click="setDeliveryInfo(2)"
                  :class="{
                    active: deliveryInfo.type === 2 && deliveryInfo.mode
                  }"
                >
                  <div class="shipping">
                    <h3>
                      SF Express
                    </h3>
                    <!-- <p>40 USD</p> -->
                  </div>
                </div>

                <h4>
                  1-2 days shipment
                </h4>
              </div>

              <div v-show="delivery === 2">
                <div
                  class="details"
                  @click="setDeliveryInfo(3)"
                  :class="{
                    active: deliveryInfo.type === 3 && deliveryInfo.mode
                  }"
                >
                  <div class="shipping">
                    <h3>
                      FedEx
                    </h3>
                    <!-- <p>40 USD</p> -->
                  </div>
                </div>

                <h4>
                  1-2 weeks shipment
                </h4>
              </div>
            </div>
          </div>

          <div class="content">
            <h1 :class="{ inactive: step <= 3 }">
              <span class="step">4</span> Payment
            </h1>

            <div class="payment" :class="{ show: step > 3 }" :key="pageIndex">
              <PayPal
                :amount="totalAmount"
                currency="USD"
                :client="credentials"
                :env="paypalEnv"
                :button-style="paypalBtnStyle"
                :disabled="true"
                @payment-completed="onPaymentSuccess($event)"
                @payment-cancelled="onPaymentCancelled()"
              >
              </PayPal>
              <!-- <div id="paypal-button-container"></div> -->
              <!-- <div class="mode" @click="setPaymentMode(1)" :class="{'active' : paymentMode === 1}">
                                    <div class="info">
                                        <h3>PayPal</h3>
                                    </div>
                                    <img src="@/assets/img/ic_paypal.png" class="icon">
                                </div> -->

              <!-- <div class="mode"  @click="setPaymentMode(2)"  :class="{'active' : paymentMode === 2}">
                                    <div class="info">
                                        <h3>PayMe</h3>
                                    </div>
                                    <img src="@/assets/img/payme.jpg" class="icon">
                                </div> -->
            </div>
          </div>
        </div>

        <div class="wrapper order-summary">
          <div class="content" ref="orderSummary">
            <h1>Order Summary</h1>

            <div class="summary">
              <table>
                <tr>
                  <td>{{ item }}</td>
                  <td>{{ computedItemAmount }} USD</td>
                </tr>

                <tr v-if="item === 'Watch'">
                  <td>Strap</td>
                  <td>{{ strapAmount }} USD</td>
                </tr>

                <tr ref="refShipping">
                  <td>Shipping</td>
                  <td>{{ `${shippingAmount} USD` }}</td>
                </tr>

                <tr ref="refDiscount">
                  <td>
                    <p>Discount</p>
                    <div class="input-wrapper">
                      <input
                        v-model="voucher"
                        type="text"
                        placeholder="Voucher code"
                      /><button class="button-cyan" @click="enterVoucher()">
                        Ok
                      </button>
                    </div>
                    <p v-if="voucherError">Voucher code is not valid!</p>
                  </td>
                  <td class="discount">-{{ computedDiscount }} USD</td>
                </tr>

                <tr ref="refTotalAmount">
                  <td>Total Amount</td>
                  <td>{{ totalAmount }} USD</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <button v-if="paymentMode" @click="submit()">SUBMIT</button> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as shopModule from "@/store/modules/shop";

import PayPal from "vue-paypal-checkout";
import InputField from "@/components/InputField";
import CustomSelect from "@/components/CustomSelect";
export default {
  data() {
    return {
      pageIndex: 0,
      step: 2,

      delivery: 1,

      editInfo: true,

      // countries: ["Hong Kong", "Philippines", "Taiwan"],

      // order details
      firstname: "",
      lastname: "",
      email: "",
      company: "",
      bldg: "",
      street: "",
      city: "",
      zipCode: "",
      country: null,
      mobile: "",
      //   kickstarterNumber: "",

      deliveryInfo: {
        type: null,
        mode: "",
        price: 0
      },

      band: {
        color: 1,
        qty: 1
      },

      paymentMode: null,

      voucher: "",

      // discount: 0,

      isEmailValid: false,
      orderId: null,

      paypalBtnStyle: {
        label: "checkout",
        size: "responsive",
        shape: "pill",
        color: "gold"
      },

      credentials: {
        sandbox:
          "AYEl0H0s9wyfmk2OGDtNOM2iuCEvHdIqqmrXoCrrG1FBhenSHW78tl52PT0DaTXlfndEe-RbnOT23DQW",
        production:
          "AQamiRvIUXuQb67mI0mbrSVppYw8niqIODEDfWcE4J_GHagp_V2bcXBJTkMZ9nCk-sp1sTzi13n7BSkg"
      },

      assets: [
        { name: "Emotions", img: "emotion" },
        { name: "Stress Level", img: "stress" },
        { name: "BPM", img: "bpm" },
        { name: "Sleep Mode", img: "sleep" },
        { name: "Lover's Mode", img: "lovers" },
        { name: "Time and Date", img: "timedate" },
        { name: "Notification", img: "notif" },
        { name: "Timer", img: "timer" },
        { name: "Calorie Burn", img: "calorie" },
        { name: "Pedometer", img: "pedometer" }
      ],

      straps: [
        { name: "Leather", price: 24, img: "leather", code: "007" },
        { name: "Red Nylon", price: 12, img: "red_nylon", code: "004" },
        { name: "Blue Nylon", price: 12, img: "blue_nylon", code: "005" },
        { name: "Black Nylon", price: 12, img: "black_nylon", code: "006" }
      ],

      addons: [
        { code: "007", qty: 0, price: 24 },
        { code: "004", qty: 0, price: 12 },
        { code: "005", qty: 0, price: 12 },
        { code: "006", qty: 0, price: 12 }
      ]

      //   isKickstarter: false
    };
  },

  beforeRouteEnter(to, from, next) {
    // ...
    if (to.query.item !== "band" && to.query.item !== "watch") {
      next("/404");
    } else next();
  },

  beforeCreate() {
    if (!this.$store._modulesNamespaceMap["shop/"]) {
      this.$store.registerModule("shop", shopModule.default);
    }
  },

  activated() {
    window.addEventListener("scroll", this.handleScroll);
    this.pageIndex += 1;
    // this.renderPaypal();
  },

  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
    this.$refs.orderSummary.style.top = `0`;
    this.clearData();
  },

  computed: {
    ...mapGetters({
      discount: "shop/getDiscount",
      voucherError: "shop/getVoucherError",

      error: "shop/getError",
      hasError: "shop/getHasError",
      countries: "shop/getCountries",
      countryListLoading: "shop/getCountryListLoading",

      buttonLoading: "shop/getButtonLoading",
      loading: "shop/getLoading"
    }),

    item() {
      return this.$route.query.item === "band" ? "Band" : "Watch";
    },

    itemAmount() {
      return this.$route.query.item === "band" ? 99.99 : 129;
    },

    strapAmount() {
      let amount = 0;
      this.addons.map(i => {
        if (i.qty > 0) amount += i.price * i.qty;
      });
      return amount;
    },

    strapQty() {
      let qty = 0;
      this.addons.map(i => {
        qty += i.qty;
      });
      return qty;
    },

    paypalEnv() {
      return process.env.VUE_APP_SERVER === "prod" ? "production" : "sandbox";
    },

    computedItemAmount() {
      return this.band.qty * this.itemAmount;
    },

    computedDiscount() {
      if (this.discount) {
        return this.discount.discount_type === "percent"
          ? (
              (this.computedItemAmount + this.strapAmount) *
              parseFloat(`.${this.discount.discount}`)
            ).toFixed(2)
          : parseFloat(this.discount.discount).toFixed(2);
      }

      return 0;
    },

    bandShippingAmount() {
      if (this.deliveryInfo.type === 2) return 6;
      if (this.deliveryInfo.type === 3) return 40;
      return 0;
    },

    watchShippingAmount() {
      if (this.deliveryInfo.type === 2) {
        if (this.band.qty > 0 && this.band.qty < 3) return 8;
        if (this.band.qty > 2 && this.band.qty < 5) return 12;
        if (this.band.qty > 4) return 15;
      }

      if (this.deliveryInfo.type === 3) {
        if (this.band.qty > 0 && this.band.qty < 3) return 35;
        if (this.band.qty > 2 && this.band.qty < 5) return 60;
        if (this.band.qty > 4) return 70;
      }
      return 0;
    },

    strapShippingAmount() {
      if (this.deliveryInfo.type === 2) {
        if (this.strapQty > 0 && this.strapQty < 3) return 8;
        if (this.strapQty > 2 && this.strapQty < 5) return 12;
        if (this.strapQty > 4) return 15;
      }

      if (this.deliveryInfo.type === 3) {
        if (this.strapQty > 0 && this.strapQty < 3) return 10;
        if (this.strapQty > 2 && this.strapQty < 5) return 16;
        if (this.strapQty > 4) return 35;
      }
      return 0;
    },

    shippingAmount() {
      return (
        (this.item === "Band"
          ? this.bandShippingAmount
          : this.watchShippingAmount) + this.strapShippingAmount
      );
    },

    totalAmount() {
      return (
        this.band.qty * this.itemAmount +
        this.strapAmount +
        this.shippingAmount -
        this.computedDiscount
      ).toFixed(2);
    },

    validateCustomerInfo() {
      return (
        this.firstname.trim() &&
        this.lastname.trim() &&
        this.email.trim() &&
        this.bldg.trim() &&
        this.street.trim() &&
        this.zipCode.trim() &&
        this.city.trim() &&
        this.country &&
        this.mobile.trim()
        // (this.isKickstarter ? this.kickstarterNumber.trim() : true)
      );
    }
  },

  watch: {
    country(val) {
      this.deliveryInfo = {
        type: null,
        mode: "",
        price: 0
      };

      if (!val) return;

      if (val.name === "Hong Kong") {
        this.delivery = 1;
      } else {
        this.delivery = 2;
      }
    },

    "deliveryInfo.price"() {
      this.$refs.refShipping.classList.add("animate");

      setTimeout(() => {
        this.$refs.refShipping.classList.remove("animate");
      }, 500);
    },

    computedDiscount() {
      this.$refs.refDiscount.classList.add("animate");

      setTimeout(() => {
        this.$refs.refDiscount.classList.remove("animate");
      }, 500);
    },

    totalAmount() {
      this.$refs.refTotalAmount.classList.add("animate");

      setTimeout(() => {
        this.$refs.refTotalAmount.classList.remove("animate");
      }, 500);
    }
  },

  components: {
    InputField,
    CustomSelect,
    PayPal
  },

  created() {
    this.getCountryList();
  },

  methods: {
    enterVoucher() {
      if (!this.voucher.trim()) {
        this.voucher = "";
        return;
      }

      let form = new FormData();
      form.append("code", this.voucher);
      form.append("email", this.email);
      form.append("product_code", this.item === "Band" ? "001" : "003");
      this.$store.dispatch("shop/enterVoucher", form);
    },

    onPaymentCancelled() {
      this.orderderId = null;
    },

    async onPaymentSuccess(data) {
      // this.$store.commit("shop/SET_LOADING", true);
      this.orderId = data.transactions[0].related_resources[0].sale.id;
      await this.submit();
      // this.$store.commit("shop/SET_LOADING", false);
    },

    // renderPaypal() {
    //   let vue = this;
    //   paypal
    //     .Buttons({
    //       createOrder: function(data, actions) {
    //         // Set up the transaction
    //         return actions.order.create({
    //           purchase_units: [
    //             {
    //               amount: {
    //                 value: vue.totalAmount
    //               }
    //             }
    //           ]
    //         });
    //       },

    //       onApprove: async function(data, actions) {
    //         vue.$store.commit("shop/SET_LOADING", true);
    //         return actions.order.capture().then(async function() {
    //           vue.orderId = data.orderID;
    //           await vue.submit();
    //           vue.$store.commit("shop/SET_LOADING", false);
    //         });
    //         // return actions.order.capture(async function(error,capture){
    //         //   console.log(error)
    //         //   console.log(error)
    //         //   vue.orderId = data.orderID;
    //         //   await vue.submit();
    //         //   vue.$store.commit("shop/SET_LOADING", false);
    //         // });
    //       },

    //       onError: () => {
    //         vue.$store.commit("shop/SET_LOADING", false);
    //         vue.$store.dispatch(
    //           "alert/setContent",
    //           {
    //             title: "Error on authentication",
    //             message: "Please logout first your paypal account",
    //             button: "Ok",
    //             hasError: true,
    //             onClose: () => {
    //               location.reload();
    //             }
    //           },
    //           { root: true }
    //         );
    //         vue.$store.dispatch("alert/toggleAlert", true, { root: true });
    //       }
    //     })
    //     .render("#paypal-button-container");
    // },

    handleScroll() {
      // mobile
      if (window.innerWidth <= 590) {
        this.$refs.orderSummary.style.top = `0`;
        return;
      }

      // desktop
      if (
        window.pageYOffset - 620 >=
        this.$refs.orderSummary.parentElement.offsetHeight - 335
      ) {
        this.$refs.orderSummary.style.top = `${this.$refs.orderSummary
          .parentElement.offsetHeight - 335}px`;
        return;
      }

      if (window.pageYOffset >= 620) {
        this.$refs.orderSummary.style.top = `${window.pageYOffset - 620}px`;
        return;
      }

      this.$refs.orderSummary.style.top = `0`;
    },

    edit() {
      this.editInfo = true;
      this.step = 1;
      this.deliveryInfo = {
        type: null,
        mode: "",
        price: 0
      };
    },

    async getCountryList() {
      await this.$store.dispatch("shop/getCountryList");
    },

    submit() {
      let form = new FormData();
      let products = [];

      if (this.band.qty > 0) {
        products.push({
          code: this.item === "Band" ? "001" : "003",
          qty: this.band.qty
        });
      }

      this.addons.map(i => {
        if (i.qty > 0) products.push(i);
      });

      form.append("first_name", this.firstname);
      form.append("last_name", this.lastname);
      form.append("email", this.email);
      form.append("company", this.company);
      form.append("bldg_apt_no", this.bldg);
      form.append("street", this.street);
      form.append("city", this.city);
      form.append("zip", this.zipCode);
      form.append("country", this.country.name);
      form.append("mobile", `${this.country.int_dialing} ${this.mobile}`);
      form.append("payment", "paypal");
      form.append("transaction_id", this.orderId);
      form.append("shipping_fee", this.shippingAmount);
      //   form.append("is_kickstarter", this.isKickstarter);
      //   if (this.isKickstarter)
      //     form.append("kickstarter_number", this.kickstarterNumber);

      if (!this.voucherError && this.discount) {
        form.append("code", this.voucher || "");
      }

      if (this.deliveryInfo.type === 1)
        form.append("delivery", "Hong Kong Post Office");
      if (this.deliveryInfo.type === 2) form.append("delivery", "SF Express");
      if (this.deliveryInfo.type === 3) form.append("delivery", "FedEx");

      products.forEach((item, index) => {
        form.append(`product[${index}][qty]`, item.qty);
        form.append(`product[${index}][code]`, item.code);
      });

      this.$store.dispatch("shop/submit", { form: form, vue: this });
    },

    clearData() {
      this.editInfo = true;

      this.firstname = "";
      this.lastname = "";
      this.email = "";
      this.company = "";
      this.bldg = "";
      this.street = "";
      this.city = "";
      this.zipCode = "";
      this.country = null;
      this.mobile = "";
      //   this.isKickstarter = false;
      //   this.kickstarterNumber = "";

      this.deliveryInfo = {
        type: null,
        mode: "",
        price: 0
      };

      this.band = {
        color: null,
        qty: 1
      };

      this.paymentMode = null;

      this.voucher = "";

      this.$store.commit("shop/SET_DISCOUNT", null);
      this.orderId = null;
      this.step = 1;

      this.addons.map(i => (i.qty = 0));
    },

    setBandColor(color) {
      this.band.color = color;
    },

    setQty(qty) {
      if (this.item === "Band") {
        if (
          (this.band.qty === 3 && qty > 0) ||
          (this.band.qty === 1 && qty < 0)
        )
          return;

        this.band.qty += qty;

        if (this.band.qty === 3) {
          this.$store.dispatch("alert/setContent", {
            title: "Thank you for ordering more!",
            message:
              "For more orders please reach out at support@upmood.com so we can send a quotation.",
            button: "Ok",
            hasError: false
          });

          this.$store.dispatch("alert/toggleAlert", true);
          this.band.qty = 2;
        }
      } else {
        if (
          (this.band.qty === 11 && qty > 0) ||
          (this.band.qty === 0 && qty < 0)
        )
          return;

        this.band.qty += qty;

        if (this.band.qty === 11) {
          this.$store.dispatch("alert/setContent", {
            title: "Thank you for ordering more!",
            message:
              "For more orders please reach out at support@upmood.com so we can send a quotation.",
            button: "Ok",
            hasError: false
          });

          this.$store.dispatch("alert/toggleAlert", true);
          this.band.qty = 10;
        }
      }
    },

    setStrapQty(code, qty) {
      if ((this.strapQty === 11 && qty > 0) || (this.strapQty === 0 && qty < 0))
        return;
      let item = this.addons.filter(i => i.code === code)[0];
      item.qty += qty;

      if (this.strapQty === 11) {
        this.$store.dispatch("alert/setContent", {
          title: "Thank you for ordering more!",
          message:
            "For more orders please reach out at support@upmood.com so we can send a quotation.",
          button: "Ok",
          hasError: false
        });

        this.$store.dispatch("alert/toggleAlert", true);
        item.qty -= 1;
      }
    },

    setDeliveryInfo(mode) {
      if (mode === 3) {
        this.deliveryInfo.mode = "Hong Kong to International";
        this.deliveryInfo.type = 3;
        this.deliveryInfo.price = 40;
        this.step = 4;
        return;
      }

      if (mode === 2) {
        this.deliveryInfo.mode = "Hong Kong to International";
        this.deliveryInfo.type = 2;
        this.deliveryInfo.price = 40;
        this.step = 4;
        return;
      }

      if (mode === 1) {
        this.deliveryInfo.mode = "Hong Kong to Hong Kong";
        this.deliveryInfo.type = 1;
        this.deliveryInfo.price = 6;
        this.step = 4;
        return;
      }
    },

    setPaymentMode(mode) {
      this.paymentMode = mode;
    },

    async validateForm() {
      let form = new FormData();

      form.append("first_name", this.firstname);
      form.append("last_name", this.lastname);
      form.append("email", this.email);
      form.append("company", this.company);
      form.append("bldg_apt_no", this.bldg);
      form.append("street", this.street);
      form.append("zip", this.zipCode);
      form.append("city", this.city);
      form.append("country", this.country.name);
      form.append("mobile", this.mobile);
      form.append("shipping_fee", this.shippingAmount);
      //   form.append("is_kickstarter", this.isKickstarter);
      //   if (this.isKickstarter)
      //     form.append("kickstarter_number", this.kickstarterNumber);

      let products = [];

      if (this.band.qty > 0) {
        products.push({
          code: this.item === "Band" ? "001" : "003",
          qty: this.band.qty
        });
      }

      this.addons.map(i => {
        if (i.qty > 0) products.push(i);
      });

      products.forEach((item, index) => {
        form.append(`product[${index}][qty]`, item.qty);
        form.append(`product[${index}][code]`, item.code);
      });

      await this.$store.dispatch("shop/validateInfo", form);
    },

    async next() {
      this.$store.commit("shop/SET_BUTTON_LOADING", true);
      //email checking
      this.isEmailValid = await this.$options.filters.verifyEmail(this.email);
      this.$store.commit("shop/SET_BUTTON_LOADING", false);
      if (!this.isEmailValid) {
        this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Email is not valid",
          button: "Close",
          hasError: true
        });
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }

      //check voucher
      this.enterVoucher();

      // validate form on backend
      await this.validateForm();
      if (this.hasError) {
        return;
      }

      this.step = 3;
      this.editInfo = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.buy-wrapper {
  display: flex;
  position: relative;
  margin-top: 160px;
  margin-bottom: 200px;
  min-width: 350px;

  @include mobile {
    flex-direction: column;
  }

  .loading-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading {
      animation-name: animate-rotating;
      animation-duration: 2s;
      animation-iteration-count: infinite;

      &:before {
        content: "";
        display: block;
        height: 30px;
        width: 30px;
        border: 10px solid #3dbfcd;
        border-radius: 50%;
      }

      &:after {
        content: "";
        display: block;
        height: 30px;
        width: 30px;
        border: 10px solid #f6cf13;
        border-radius: 50%;
      }
    }
  }

  .wave-top {
    position: absolute;
    display: block;
    top: -170px;
    width: 115%;
    right: -325px;

    @include mobile {
      display: none;
    }
  }

  .wave-top-mobile {
    display: none;

    @include mobile {
      position: absolute;
      top: -100px;
      left: 0;
      width: 115%;
      height: 100px;
      display: block;
    }
  }

  .wrapper {
    z-index: +1;

    &.customer {
      margin-right: 30px;
      width: 544px;

      @include mobile {
        margin-right: 0;
        width: 100%;
      }
    }

    span.step {
      color: $color7;
      margin-right: 10px;
    }

    /deep/ .input-wrapper,
    .select-wrapper {
      width: 200px;
      margin-right: 20px;

      @include mobile {
        width: 100%;
        margin-right: 0;
      }
    }

    .group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;

      label {
        font-size: 18px;
        color: #7f908c;
        padding: 10px;
        margin-top: 10px;
        margin-right: 10px;
        border: 1px solid #a7a7a7;
        border-radius: 5px;
        display: inline-block;

        &.disabled {
          opacity: 0.5;
        }
      }
    }

    // .kickstarter-wrapper {
    //   display: flex;
    //   align-items: center;
    //   margin-top: 20px;

    //   .label {
    //     color: #757575;
    //     font-size: 24px;
    //   }

    //   .checkbox {
    //     -webkit-appearance: none;
    //     width: 30px;
    //     height: 30px;
    //     background: white;
    //     border-radius: 3px;
    //     border: 1px solid #d3d3d3;
    //     margin-right: 10px;

    //     &:checked {
    //       background: #3dbfcd;
    //     }
    //   }
    // }

    // .kickstarter-number {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: start;
    //   padding-left: 42px;
    //   margin-top: 10px;

    //   h3 {
    //     color: #757575;
    //     font-size: 24px;
    //     font-weight: 400;
    //   }

    //   h5 {
    //     text-align: left;
    //     font-size: 12px;
    //     color: #9ca0a0;
    //     opacity: 1;
    //     width: 60%;
    //   }

    //   .input-wrapper {
    //     padding: 10px 0px;
    //   }
    // }

    h1 {
      font-size: 26px;
      color: #7f908c;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding: 20px;
      position: relative;

      &.inactive {
        background-color: #f7f7f7;
        color: #a7a7a7;

        span {
          color: #a7a7a7;
        }
      }
    }

    h2 {
      padding: 0 20px;
      font-size: 20px;
      color: #7f908c;
    }

    .content {
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      background-color: #fff;
      border-radius: 5px;
      margin-bottom: 20px;
    }

    .note {
      font-size: 14px;
      color: #dbc45b;
    }

    .band {
      .details {
        padding: 10px 20px;
        display: flex;
        align-items: center;

        @include mobile {
          flex-direction: column;
          align-items: flex-start;
        }

        .colors {
          display: flex;
          align-items: center;

          span {
            flex-shrink: 0;
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
            cursor: pointer;

            &.sea-green {
              background-color: #3dbfcd;
            }

            &.yellow {
              background-color: #f6cf13;
            }

            &.black {
              background-color: #4a4a4a;
            }

            &.active {
              height: 35px;
              width: 35px;
            }
          }
        }

        .qty {
          display: flex;
          align-items: center;

          .button-white {
            padding: 3px 5px;

            &:disabled {
              pointer-events: none;
              opacity: 0.5;
            }
          }
        }
      }

      .strap-wrapper {
        display: flex;
        flex-direction: column;
        padding: 10px 20px;

        .strap {
          margin-bottom: 15px;
        }

        .item-wrapper {
          display: flex;
          padding-left: 20px;

          @include mobile {
            flex-direction: column;
            width: 100%;
          }

          .item-container {
            align-items: center;
            display: flex;
            flex: 1 1 auto;
            margin-right: 30px;

            @include mobile {
              margin-right: unset;
            }

            h2 {
              padding: 0px;
            }

            span {
              &.item {
                color: #6c7774;
                font-size: 24px;
                width: 127px;
              }

              &.price {
                margin-left: auto;
                color: #7f918c;
                font-size: 24px;
              }
            }

            &.band {
              margin-right: 100px;
            }
          }

          .item-details {
            flex: 1 1 auto;
            display: flex;
            align-items: center;

            span {
              flex-shrink: 0;
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
              cursor: pointer;

              &.black {
                background-color: #4a4a4a;
              }

              &.active {
                height: 35px;
                width: 35px;
              }
            }

            .qty {
              margin-left: auto;
              display: flex;
              align-items: center;

              .button-white {
                padding: 3px 5px;

                &:disabled {
                  pointer-events: none;
                  opacity: 0.5;
                }
              }
            }
          }
        }
      }
    }

    .icon-edit {
      position: absolute;
      display: inline-block;
      top: 20px;
      right: 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .customer-info {
      .info,
      .delivery {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 20px;
      }

      .next {
        text-align: right;
        padding: 10px 20px;

        button {
          width: 100px;
          margin-bottom: 10px;

          &:disabled {
            pointer-events: none;
            opacity: 0.5;
          }
        }
      }
    }

    .customer-info-summary {
      padding: 20px;

      p {
        margin-bottom: 10px;
        color: #7f908c;
      }

      h2 {
        margin-bottom: 10px;
        margin-top: 20px;
        padding: 0;
      }
    }

    .delivery {
      padding: 20px;

      .details {
        padding: 20px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        width: 100%;
        max-width: 300px;
        margin-bottom: 20px;
        cursor: pointer;
        position: relative;

        &:after {
          content: "";
          display: inline-block;
          position: absolute;
          bottom: 20px;
          right: 20px;
          height: 20px;
          width: 20px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          border-radius: 50%;
        }

        h3 {
          font-size: 18px;
          color: #7f908c;
        }

        p {
          font-size: 16px;
          color: $color4;
        }

        &:hover,
        &.active {
          border-color: #3dbfcd;

          &:after {
            border-color: #3dbfcd;
          }
        }

        &.active {
          &:after {
            background-color: #3dbfcd;
            content: "\2713";
            color: #fff;
            text-align: center;
          }
        }
      }

      h4 {
        margin-left: 10px;
        color: #7f908c;
        font-size: 16px;
      }
    }

    .payment {
      display: none;
      margin-top: 20px;

      &.show {
        display: block;
        padding: 10px 20px 20px 20px;
      }

      // .mode {
      //   display: flex;
      //   align-items: center;
      //   border: 1px solid rgba(0, 0, 0, 0.1);
      //   padding: 15px;
      //   border-radius: 10px;
      //   margin-bottom: 20px;
      //   cursor: pointer;
      //   position: relative;

      //   .info {
      //     flex: 1 1 auto;

      //     h3 {
      //       color: #7f908c;
      //     }
      //   }

      //   .icon {
      //     height: 50px;
      //     width: 50px;
      //     margin-right: 20px;
      //   }

      //   &:after {
      //     content: "";
      //     display: inline-block;
      //     height: 20px;
      //     width: 20px;
      //     border: 1px solid rgba(0, 0, 0, 0.2);
      //     border-radius: 50%;
      //   }

      //   &:hover,
      //   &.active {
      //     border-color: #3dbfcd;

      //     &:after {
      //       border-color: #3dbfcd;
      //     }
      //   }

      //   &.active {
      //     &:after {
      //       background-color: #3dbfcd;
      //       content: "\2713";
      //       color: #fff;
      //       text-align: center;
      //     }
      //   }
      // }
    }

    &.order-summary {
      .content {
        position: relative;
        width: 350px;

        @include mobile {
          width: 100%;
          top: 0 !important;
        }

        h1 {
          text-align: center;
        }

        .summary {
          padding: 20px;

          table {
            width: 100%;
            border-collapse: collapse;

            tr {
              display: flex;
              align-items: center;
              background-color: #fff;

              &.animate {
                animation-name: pulse;
                animation-duration: 1s;

                td {
                  color: #fff;
                }
              }

              td {
                font-size: 18px;
                color: #7f908c;
                padding: 10px;

                &.discount {
                  color: #f07c52;
                }

                &:first-child {
                  flex: 1 1 auto;
                }

                &:last-child {
                  text-align: right;
                }

                .input-wrapper {
                  width: 90%;
                  display: flex;

                  input {
                    flex: 1 1 auto;
                    padding: 10px;
                    border: 1px solid #a7a7a7;
                    border-right: 0;
                    margin: 0;
                  }

                  .button-cyan {
                    padding: 10px;
                    border: 1px solid #a7a7a7;
                    border-left: 0;
                    margin: 0;
                  }
                }
              }

              @keyframes pulse {
                0% {
                  background-color: #fff;
                }

                50% {
                  background-color: rgba(91, 185, 251, 0.5);
                }

                100% {
                  background-color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}

.watch-wrapper {
  display: flex;
  flex: 1 1 auto;
  padding: 0px;
  width: 919px;
  height: 450px;
  border-radius: 5px;
  margin: 0px auto 40px;
  box-shadow: 0px 1px 6px #00000029;

  @include mobile {
    flex-direction: column;
    width: unset;
    padding-bottom: 20px;
    height: 800px;
  }

  .image-wrapper {
    position: relative;
    padding: 50px 0px 0px 50px;
    width: 47%;

    @include mobile {
      margin: auto;
      position: unset;
      padding: unset;
      width: unset;
    }

    .watch-1 {
      z-index: +1;
      position: absolute;

      @include mobile {
        position: unset;
      }
    }

    .watch-2 {
      position: absolute;
      top: 25px;
      left: 80px;

      @include mobile {
        display: none;
      }
    }
  }

  .title-container {
    padding-top: 30px;
    width: 53%;
    text-align: center;

    @include mobile {
      width: unset;
    }

    .watch-logo {
      margin: auto;
      margin-bottom: 20px;
    }

    h2 {
      color: #2d4e52;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .desc {
      color: #2d4e52;
      font-weight: 600;
      font-size: 13px;
    }

    .features {
      width: 425px;
      margin: 30px auto 25px;

      @include mobile {
        width: 300px;
      }
    }

    .note {
      color: #838d8e;
      font-size: 14px;
    }
  }
}
</style>
